import { render } from "./BuyBookSessions.vue?vue&type=template&id=0ae2ff80"
import script from "./BuyBookSessions.vue?vue&type=script&lang=js"
export * from "./BuyBookSessions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Buyback/BuyBookSessions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ae2ff80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ae2ff80', __exports__)) {
    api.reload('0ae2ff80', __exports__)
  }
  
  module.hot.accept("./BuyBookSessions.vue?vue&type=template&id=0ae2ff80", () => {
    api.rerender('0ae2ff80', render)
  })

}


export default __exports__